import React, { useEffect, useState } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';

import arrayMutators from 'final-form-arrays';

import {
  Button,
  FieldBirthdayInput,
  FieldCheckboxGroup,
  FieldCustomSelect,
  FieldDateInput,
  FieldDateRangeController,
  FieldNumberInput,
  FieldReference,
  FieldTextInput,
  FieldTimeZoneSelect,
  Form,
  InlineTextButton,
} from '../../components';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import css from './EditListingSchedulingForm.module.css';
import FieldDateAndTimeInput from '../BookingTimeForm/FieldDateAndTimeInput';
import TimeAmPm from '../../components/TimeAMPM/TimeAmPm';
import { FieldArray } from 'react-final-form-arrays';
import { findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';
import {
  recurringDaysOptions,
  recurringInterval,
  minuteOptions,
  hourOptions,
  UnpaidBreakOptions,
  listingScheduleType,
  MIN_START_HOUR_DIFF,
  MIN_WORKING_HOUR,
  MAX_WORKING_HOUR,
  MAX_START_HOUR,
  AVERAGE_WORKING_HOUR,
} from '../../marketplace-custom-config';
import moment from 'moment';
import { BsPlusLg } from 'react-icons/bs';
import { ReactComponent as InfoIcon } from '../../assets/svg/infoIcon.svg';

import { Tooltip } from 'react-tooltip';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
const textfield = 'textfield';
const errorTextField = 'errorTextField';

const initialiZeHoursOptions = ({ oneTimeScheduleList, recurringScheduleList, scheduleType }) => {
  const [dateTime] =
    (scheduleType === listingScheduleType.oneTime
      ? oneTimeScheduleList
      : scheduleType === listingScheduleType.recurring
        ? recurringScheduleList
        : []) || [];
  if (!dateTime) return [];

  const { startDate, startTime, endTime } = dateTime;
  const {
    hours: { value: hvalue },
    min: { value: mvalue },
  } = startTime;
  const {
    min: { value: endMValue },
  } = endTime;

  const minStartDate = moment()
    .add(MIN_START_HOUR_DIFF, 'hours')
    .add(0, 'minutes');

  const gigStart = moment(startDate);
  const isSelectedDateAfterMinStartDate = moment(gigStart).isAfter(minStartDate, 'date');
  const startHour = parseInt(hvalue);
  const endHour = startHour + MAX_WORKING_HOUR;
  let startHourArray = hourOptions,
    startMinuteArray = minuteOptions,
    endHourArray = hourOptions,
    endMinuteArray = minuteOptions;
  const maxEndHour = (startHour + MAX_WORKING_HOUR) % 24;
  const minEndHour = (startHour + MIN_WORKING_HOUR) % 24;

  if (!isSelectedDateAfterMinStartDate) {
    startHourArray = hourOptions.filter(hour => hour.value >= startHour);
  }
  startHourArray = startHourArray.filter(hour => hour.value <= MAX_START_HOUR);
  endHourArray = endHourArray.filter(f =>
    minEndHour > maxEndHour
      ? f?.value >= minEndHour || f.value <= maxEndHour
      : f?.value >= minEndHour && f.value <= maxEndHour
  );
  startMinuteArray = startMinuteArray.filter(min => min.value <= mvalue);
  endMinuteArray = endMinuteArray.filter(min => min.value <= endMValue);

  return [startHourArray, endHourArray, startMinuteArray, endMinuteArray];
};

const EditListingSchedulingFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        values,
        certificateOptions,
        className,
        disabled,
        ready,
        handleSubmit,
        initialValues,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        filterConfig,
        updateInProgress,
        fetchErrors,
        formApi,
        formId,
        isRequired,
        name,
        form,
        tab,
        userNativeLang,
        tooltipDesc,
        setCurrentTab,
        history,
      } = formRenderProps;
      formApi.current = form;
      const [selectedDates, setSelectedDates] = useState(
        values?.selectedDates ? values?.selectedDates : []
      );

      const [validStartDate, setValidStartDate] = useState(true);

      const removeSelectedDate = (fieldName, indx) => {
        setSelectedDates(prevSelectedDates =>
          prevSelectedDates.filter(item => item.fieldName !== fieldName)
        );
      };

      //Select Date OT tab

      const selectDateLabel = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.selectDateLabel',
      });

      // End Date Rec Tab
      const startDateLabel = intl.formatMessage({
        id: 'WorkerExpForm.startDateLabel',
      });
      const endDateLabel = intl.formatMessage({
        id: 'WorkerExpForm.endDateLabel',
      });
      const RequiredMessage = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.RequiredMessage',
      });
      const startTitleValidator = isRequired ? validators.required(RequiredMessage) : null;
      //recurringIntervalLabel
      const recurringIntervalLabel = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.recurringIntervalLabel',
      });
      const recurringIntervalPlaceholder = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.recurringIntervalPlaceholder',
      });
      //Start Time

      const startTimeLabel = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.startTimeLabel',
      });
      const endTimeLabel = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.endTimeLabel',
      });
      const hourLabel = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.hourLabel',
      });
      const minuteLabel = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.minuteLabel',
      });
      const startTimeValidator = isRequired ? validators.required(RequiredMessage) : null;

      const addTimePeriodBtnLabel = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.addTimePeriodBtnLabel',
      });
      //End Time

      const endTimeValidator = isRequired ? validators.required(RequiredMessage) : null;

      //unpaidBreak

      const breakTimeMessage = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.breakTimeMessage',
      });
      const unpaidBreakPlaceholder = intl.formatMessage({
        id: 'EditListingSchedulingOneTimeForm.unpaidBreakPlaceholder',
      });
      const breakTimeValidator = isRequired ? validators.required(RequiredMessage) : null;

      const { updateListingError, createListingDraftError, showListingsError } = fetchErrors || {};
      const errorMessageUpdateListing = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageCreateListingDraft = createListingDraftError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;

      const { oneTimeScheduleList, recurringScheduleList, scheduleType: vScheduleType } = values;
      const [endTimeOptions, setEndTimeOptions] = useState([]);
      const [endTimeMinOptions, setEndTimeMinOptions] = useState([]);
      const [hourOptionsArray, setHourOptionsArray] = useState([]);
      const [minuteOptionsArray, setMinuteOptionsArray] = useState([]);
      const [startHour, setStartHour] = useState();
      const [startMinute, setStartMinute] = useState();
      const [endMinute, setEndMinute] = useState();
      const [endHour, setEndHour] = useState();
      const [selectedDate, setSelectedDate] = useState();
      const [minStartDate, setMinStartDate] = useState()
      const [scheduleType, setScheduleType] = useState(
        values?.scheduleType ? values?.scheduleType : listingScheduleType.oneTime
      );
      const [validDateRange, setValidDateRange] = useState(null);
      //valid date range check
      const getWorkingHourDiff = (startHour, endHour) => {
        return startHour > endHour ? 24 - startHour + endHour : endHour - startHour;
      };

      const computeEndTimeMinOptions = (workingDiff, startMinuteValue, endHourValue, startHourValue) => {
        if (workingDiff < MIN_WORKING_HOUR || workingDiff > MAX_WORKING_HOUR) return [];

        if (workingDiff === MIN_WORKING_HOUR) {
          return minuteOptions.filter(m => parseInt(m.value) >= startMinuteValue);
        }

        else if (workingDiff >= MAX_WORKING_HOUR) {
          return minuteOptions.filter(m => parseInt(m.value) <= startMinuteValue);
        }

        else {
          return minuteOptions;
        }
      };

      const computeEndTimeHourOptions = (startHourValue) => {
        const startHour = typeof startHourValue === 'object' ? parseInt(startHourValue.value) : parseInt(startHourValue);

        const minEndHour = (startHour + MIN_WORKING_HOUR) % 24;
        const maxEndHour = (startHour + MAX_WORKING_HOUR) % 24;

        if (minEndHour > maxEndHour) {
          return hourOptions.filter(hour =>
            hour.value >= minEndHour || hour.value <= maxEndHour
          );
        }

        return hourOptions.filter(hour =>
          hour.value >= minEndHour && hour.value <= maxEndHour
        );
      };

      const computeMinuteOptions = (startHourValue, minStartHour, minStartMinute) => {
        return (startHourValue > minStartHour)
          ? minuteOptions
          : minuteOptions.filter(min => min.value >= minStartMinute);
      };

      const updateEndTimeMinOptions = (diff, startMinuteValue, endHourValue, startHourValue) => {
        const endTimeMinOp = computeEndTimeMinOptions(diff, startMinuteValue, endHourValue, startHourValue);
        setEndTimeMinOptions(endTimeMinOp);
      };

      const handleStartTimeOptions = (selectedDateTime, minStartDateTime, fieldName) => {
        setMinStartDate(minStartDateTime)
        setSelectedDate(selectedDateTime);

        const startHourValue = parseInt(startHour?.value || 0, 10);
        const endHourValue = parseInt(endHour?.value || 0, 10);
        const startMinuteValue = parseInt(startMinute?.value || 60, 10);
        const endMinuteValue = parseInt(endMinute?.value || 60, 10);

        const isBeforeStartDate = moment(selectedDateTime).isBefore(minStartDateTime, 'day');
        if (isBeforeStartDate) return;

        let effectiveMinStartHour = 0;
        let effectiveMinStartMinute = 0;

        const isSelectedDateAfterMinStartDate = moment(selectedDateTime).isAfter(minStartDateTime, 'day');
        let modifiedHourArray = [...hourOptions];

        const isBeforeMinHour = startHourValue < minStartDateTime.hour();
        const isBeforeMinMinute = startMinuteValue < minStartDateTime.minute();
        const isSameMinHour = startHourValue == minStartDateTime.hour();

        if (!isSelectedDateAfterMinStartDate) {
          effectiveMinStartHour = minStartDateTime.hour();
          effectiveMinStartMinute = minStartDateTime.minute();
          modifiedHourArray = hourOptions.filter(hour => hour.value >= minStartDateTime.hour());

          if (minStartDateTime.minute() > 45) {
            modifiedHourArray = modifiedHourArray.filter((_, i) => i !== 0);
          }

          if (isBeforeMinHour || (isSameMinHour && isBeforeMinMinute)) {
            form.batch(() => {
              form.change(`${fieldName}.startTime.hours`, '');
              form.change(`${fieldName}.startTime.min`, '');
              form.change(`${fieldName}.endTime.hours`, '');
              form.change(`${fieldName}.endTime.min`, '');
            });

            setStartHour(undefined);
            setStartMinute(undefined);
            setEndHour(undefined);
            setEndMinute(undefined);
          }
        }

        else {
          modifiedHourArray = modifiedHourArray.filter(hour => hour.value <= MAX_START_HOUR);
        }

        setHourOptionsArray(modifiedHourArray);

        const workingDiff = getWorkingHourDiff(startHourValue, endHourValue);

        const minuteOpts = computeMinuteOptions(startHourValue, effectiveMinStartHour,
          effectiveMinStartMinute);
        setMinuteOptionsArray(minuteOpts);

        const endTimeMinOptions = computeEndTimeMinOptions(workingDiff, startMinuteValue, endHourValue, startHourValue);
        setEndTimeMinOptions(endTimeMinOptions);

        if (workingDiff === MIN_WORKING_HOUR && endMinuteValue < startMinuteValue) {
          setEndMinute(startMinute);
          form.batch(() => {
            form.change(`${fieldName}.endTime.min`, startMinute);
          });
        }

      };

      const handleStartTimeChange = ({
        val,
        fieldName,
        minStartHour,
        minStartMinute
      }) => {
        const startHourValue = parseInt(val.value, 10);
        const computedEndHour = (startHourValue + AVERAGE_WORKING_HOUR) % 24;
        let endHourValue = hourOptions.find(h => parseInt(h.value, 10) === computedEndHour) ?? endTimeOptions[0];
        const minimumEndHour = parseInt(val.value, 10) + MIN_WORKING_HOUR;
        let nextMinHourOption = minimumEndHour;

        if (minimumEndHour > 24) {
          nextMinHourOption = minimumEndHour - 24;
        }

        form.batch(() => {
          if (!endHour) {
            setEndHour(endHourValue);
            form.change(`${fieldName}.endTime.hours`, endHourValue);
          }

          else if (val.value === endHour.value || parseInt(endHour.value, 10) < minimumEndHour) {
            const nextHourOption = hourOptions.find(h => parseInt(h.value, 10) === nextMinHourOption);

            if (nextHourOption) {
              setEndHour(nextHourOption);
              form.change(`${fieldName}.endTime.hours`, nextHourOption);
              endHourValue = nextHourOption;
            }

            else {
              endHourValue = endHour;
            }
          }

          else {
            endHourValue = endHour;
            setEndHour(endHourValue);
          }

          setStartHour(val);
          form.change(`${fieldName}.startTime.hours`, val);

          setEndMinute(endMinute);
          form.change(`${fieldName}.endTime.min`, endMinute);

          const minuteOpts = computeMinuteOptions(startHourValue, minStartHour, minStartMinute);
          setMinuteOptionsArray(minuteOpts);

          if (startMinute != undefined && minuteOpts.some(opt => opt.value === startMinute.value)) {
            form.change(`${fieldName}.startTime.min`, startMinute);

            const endTimeOpts = computeEndTimeHourOptions(val);
            setEndTimeOptions(endTimeOpts);

            const diff = getWorkingHourDiff(startHourValue, parseInt(endHourValue.value));

            if (diff === MIN_WORKING_HOUR) {
              if (endMinute < startMinute) {
                form.batch(() => {
                  form.change(`${fieldName}.endTime.min`, startMinute);
                });
                setEndMinute(startMinute);
              }
              const startMinuteValue = parseInt(startMinute?.value || 60, 10);
              updateEndTimeMinOptions(diff, startMinuteValue, endHourValue, startHourValue);
            }

            else {
              updateEndTimeMinOptions(diff, parseInt(minuteOpts[0].value, 10), endHourValue, startHourValue);
            }
          }

          else {
            setStartMinute(minuteOpts[0]);
            form.change(`${fieldName}.startTime.min`, minuteOpts[0]);

            const endTimeOpts = computeEndTimeHourOptions(val);
            setEndTimeOptions(endTimeOpts);

            const diff = getWorkingHourDiff(startHourValue, parseInt(endHourValue.value));
            updateEndTimeMinOptions(diff, parseInt(minuteOpts[0].value, 10), endHourValue, startHourValue);

            setEndMinute(minuteOpts[0]);
            form.change(`${fieldName}.endTime.min`, minuteOpts[0]);
          }
        });
      };

      const handleEndTimeChange = ({ val, fieldName }) => {
        const startHourValue = parseInt(startHour?.value || 0, 10);
        const endHourValue = parseInt(val?.value || 0, 10);
        const startMinuteValue = parseInt(startMinute?.value || 60, 10);
        const endMinuteValue = parseInt(endMinute?.value || 0, 10);

        const diff = getWorkingHourDiff(startHourValue, endHourValue);
        if (diff === MIN_WORKING_HOUR && endMinuteValue < startMinuteValue) {
          form.batch(() => {
            setEndMinute(startMinute);
            form.change(`${fieldName}.endTime.min`, startMinute);
          });
        }
        updateEndTimeMinOptions(diff, startMinuteValue, endHourValue, startHourValue);

        setEndHour(val);
        form.change(`${fieldName}.endTime.hours`, val);
      };

      const handleStartTimeMinChange = (val, fieldName) => {
        form.batch(() => {
          const startHourValue = parseInt(startHour?.value || 0, 10);
          const startMinuteValue = parseInt(val.value || 0, 10);
          const endHourValue = parseInt(endHour?.value || 0, 10);

          setStartMinute(val);
          form.change(`${fieldName}.startTime.min`, val);

          const diff = getWorkingHourDiff(startHourValue, endHourValue);
          updateEndTimeMinOptions(diff, startMinuteValue, endHourValue, startHourValue);

          setEndMinute(val);
          form.change(`${fieldName}.endTime.min`, val);
        });
      };

      const handleEndTimeMinChange = (val, fieldName) => {
        form.batch(() => {
          setEndMinute(val);
          form.change(`${fieldName}.endTime.min`, val);
        });
      };

      const handleRecurringStartTimeChange = ({
        val,
        fieldName,
        minStartHour,
        minStartMinute,

      }) => {
        setStartHour(val);
        setEndHour(undefined);
        setStartMinute(undefined);
        setEndMinute(undefined);
        form.change(`${fieldName}.startTime.min`, '');
        form.change(`${fieldName}.endTime.hours`, '');
        form.change(`${fieldName}.endTime.min`, '');
        form.change(`${fieldName}.startTime.hours`, val);
        //to achieve next day time slot
        const startHourValue = parseInt(val.value);

        const endTimeOpts = computeEndTimeHourOptions(startHourValue);
        const minuteOpts = computeMinuteOptions(val.value, minStartHour, minStartMinute);

        setEndTimeOptions(endTimeOpts);
        setMinuteOptionsArray(minuteOpts);
      };

      const handleRecurringEndTimeChange = ({ val, fieldName }) => {
        const startHourValue = parseInt(values?.recurringScheduleList[indx].startTime.hours?.value || 0);
        const endHourValue = parseInt(val?.value || 0);
        const startMinuteValue = parseInt(values?.recurringScheduleList[indx].startTime.min?.value || 60);

        const workingDiff = getWorkingHourDiff(startHourValue, endHourValue);

        const endTimeMinOptions = computeEndTimeMinOptions(workingDiff, startMinuteValue, endHourValue, startHourValue);
        setEndTimeMinOptions(endTimeMinOptions);

        setEndHour(val);
        form.change(`${fieldName}.endTime.hours`, val);
      };

      const onetimeFieldCompleted = !!(
        oneTimeScheduleList &&
        Array.isArray(oneTimeScheduleList) &&
        oneTimeScheduleList.length > 0 &&
        oneTimeScheduleList.every(
          schedule =>
            !!(
              schedule.startDate &&
              schedule.startDate.date &&
              schedule.endTime &&
              schedule.endTime.hours &&
              schedule.endTime.min &&
              schedule.startTime &&
              schedule.startTime.hours &&
              schedule.startTime.min
            )
        )
      );

      const recurringFieldCompleted = !!(
        recurringScheduleList &&
        Array.isArray(recurringScheduleList) &&
        recurringScheduleList.length > 0 &&
        recurringScheduleList.every(schedule => {
          return !!(
            schedule.recurringInterval &&
            schedule.recurringInterval.value &&
            schedule.startDate &&
            schedule.startDate.date &&
            schedule.endDate &&
            schedule.endDate.date &&
            schedule.endTime &&
            schedule.endTime.hours &&
            schedule.endTime.min &&
            schedule.startTime &&
            schedule.startTime.hours &&
            schedule.startTime.min
          );
        })
      );

      const isDateRangeValid = (startDate, endDate, recurringDays) => {
        startDate = moment(startDate);
        endDate = moment(endDate);

        // Generate an array of all the dates between startDate and endDate
        const dateRange = [];
        let currentDate = startDate.clone();

        while (currentDate.isSameOrBefore(endDate)) {
          dateRange.push(currentDate.clone());
          currentDate.add(1, 'day');
        }

        const dayNameToNumber = {
          sunday: 0,
          monday: 1,
          tuesday: 2,
          wednesday: 3,
          thursday: 4,
          friday: 5,
          saturday: 6,
        };

        const recurringDayNumbers = recurringDays.map(day => {
          const numberArr = dayNameToNumber[day.toLowerCase()];

          return numberArr;
        });

        const allRecurringDaysInRange = recurringDayNumbers.every(dayNumber => {
          return dateRange.some(date => {
            const dayNum = date.isoWeekday();
            const dayNumb = dayNum === 7 ? 0 : dayNum;
            return dayNumb === dayNumber;
          });
        });
        setValidDateRange(allRecurringDaysInRange);
      };

      const handleRecurringDaysChange = values => {
        if (values.scheduleType !== listingScheduleType.recurring) return;
        const {
          recurringScheduleList: [recurringDetails],
        } = values;
        const hasValidDate =
          recurringDetails &&
          recurringDetails.startDate?.date &&
          recurringDetails.endDate?.date &&
          recurringDetails?.recurringDays;
        if (hasValidDate) {
          isDateRangeValid(
            recurringDetails.startDate?.date,
            recurringDetails.endDate?.date,
            recurringDetails?.recurringDays
          );
        }
      };

      const handleFormSpyChange = values => {
        handleRecurringDaysChange(values.values);
      };

      // start date validity checking

      const { startDate, startTime } =
        values?.scheduleType === listingScheduleType.oneTime
          ? values?.oneTimeScheduleList?.[0]
          : values?.recurringScheduleList?.[0];
      let listingStartDateTime =
        values?.scheduleType &&
        startDate?.date &&
        startTime?.min?.value &&
        startTime?.min?.value &&
        moment(startDate?.date).set({
          hours: startTime?.hours?.value,
          minutes: startTime?.min?.value,
          seconds: 0,
        });
      let isValidStartDate =
        values?.scheduleType && listingStartDateTime
          ? moment()
            .add(MIN_START_HOUR_DIFF, 'hours')
            .isBefore(moment(listingStartDateTime))
          : true;

      const submitDisabled =
        pristine ||
        disabled ||
        submitInProgress ||
        (scheduleType === listingScheduleType.oneTime && !onetimeFieldCompleted) ||
        (scheduleType === listingScheduleType.recurring && !recurringFieldCompleted) ||
        (scheduleType === listingScheduleType.recurring &&
          recurringScheduleList?.[0].recurringInterval?.value === 'Weekly' &&
          validDateRange === false) ||
        !isValidStartDate;

      useEffect(() => {
        if (isValidStartDate === false) {
          setValidStartDate(false);
        }
      }, [isValidStartDate]);

      useEffect(() => {
        const initialValues = initialiZeHoursOptions({
          oneTimeScheduleList,
          recurringScheduleList,
          scheduleType: vScheduleType,
        });

        if (initialValues.length === 4) {
          const [startHourArray, endHourArray, startMinuteArray, endMinuteArray] = initialValues;
          setEndTimeOptions(endHourArray);
          setEndTimeMinOptions(endMinuteArray);
          setHourOptionsArray(startHourArray);
          setMinuteOptionsArray(startMinuteArray);
        }
      }, []);

      return (
        <Form
          className={classes}
          onSubmit={e => {
            values.scheduleType = scheduleType;
            handleSubmit(e);
          }}
        >
          {errorMessageCreateListingDraft}
          {errorMessageUpdateListing}
          {errorMessageShowListing}
          <FormSpy subscription={{ values: true }} onChange={handleFormSpyChange} />
          <div>
            <span className={css.tabDiv}>
              <button
                type="button"
                className={classNames(css.desktopReviewsTabNav, {
                  [css.selectedTab]: tab === 'OneTimeTab',
                  [css.tabDisabled]:
                    values?.scheduleType && values?.scheduleType === listingScheduleType.oneTime,
                })}
                onClick={() => {
                  setCurrentTab('OneTimeTab');
                  setScheduleType(listingScheduleType.oneTime);
                }}
                disabled={
                  values?.scheduleType && values?.scheduleType === listingScheduleType.oneTime
                }
              >
                <FormattedMessage id="EditListingAvailabilityPanel.OneTime" />
              </button>

              <button
                type="button"
                className={classNames(css.desktopReviewsTabNav, {
                  [css.selectedTab]: tab === 'RecurringTab',
                  [css.tabDisabled]: true,
                  [css.customDisabled]: true,
                })}
                onClick={() => {
                  setCurrentTab('RecurringTab');
                  setScheduleType(listingScheduleType.recurring);
                }}
                data-tooltip-id="recurring-blocked"
                data-tooltip-content={intl.formatMessage({
                  id: 'EditListingSchedulingFormComponent.recurringCommingSoon',
                })}
                disabled={
                  true

                }
              >
                <FormattedMessage id="EditListingAvailabilityPanel.Recurring" />
              </button>
              <Tooltip id="recurring-blocked" className={css.tooltip} />

              <span className={css.slider}></span>
            </span>
          </div>
          {(tab === 'OneTimeTab' && values?.scheduleType === listingScheduleType.oneTime) ||
            (tab === 'RecurringTab' && values?.scheduleType === listingScheduleType.recurring) ? (
            <span className={css.typeInfo}>
              <InfoIcon />

              <FormattedMessage
                id="EditListingAvailabilityPanel.scheduleTypeChangeInfo"
                values={{
                  type: (
                    <span>
                      {values?.scheduleType === listingScheduleType.oneTime
                        ? intl.formatMessage({ id: 'EditListingAvailabilityPanel.OneTime' })
                        : intl.formatMessage({ id: 'EditListingAvailabilityPanel.Recurring' })}
                    </span>
                  ),
                }}
              />
            </span>
          ) : null}
          {tab === 'OneTimeTab' ? (
            <FieldArray name={'oneTimeScheduleList'}>
              {({ fields }) => {
                const { name } = fields;
                return (
                  <div>
                    {fields.map((fieldName, indx) => {

                      const minimumStartDate = moment()
                        .add(MIN_START_HOUR_DIFF, 'hours')
                        .add(0, 'minutes');

                      return (
                        <div
                          className={classNames(css.OneTimeMainContainer, {
                            [css.invalidSchedule]:
                              isValidStartDate === false && validStartDate === false,
                          })}
                          key={`onetm${indx}`}
                        >
                          <div className={css.SelectDateContainer}>
                            <FieldDateInput
                              id={`${fieldName}.startDate`}
                              name={`${fieldName}.startDate`}
                              className={classNames(css.datefield, textfield)}
                              label={selectDateLabel}
                              validate={startTitleValidator}
                              errorClassName={errorTextField}
                              userNativeLang={userNativeLang}
                              isDayBlocked={date => {
                                const selected = moment(date);

                                if (selected.isBefore(minimumStartDate, 'day')) return true;

                                const isToday = selected.isSame(moment(), 'day');
                                if (selected.isSame(minimumStartDate, 'day') && isToday) {
                                  const diffInHours = minimumStartDate.hour() - moment().hour();
                                  return diffInHours < MIN_START_HOUR_DIFF;
                                }

                                return false;
                              }}
                              onChange={startDate => {
                                form.change(`${fieldName}.endDate.date`, '');
                                setValidDateRange(null);
                                const selectedDateTime = moment(startDate.date)
                                  .set({
                                    hour: startHour,
                                    minute: startMinute,
                                    second: 0
                                  });

                                handleStartTimeOptions(
                                  selectedDateTime,
                                  minimumStartDate,
                                  fieldName
                                );
                              }}
                            />
                            <span
                              className={css.clearBtn}
                              onClick={() => {
                                form.batch(() => {
                                  form.change(`${fieldName}.startTime.min`, '');

                                  form.change(`${fieldName}.endTime.hours`, '');
                                  form.change(`${fieldName}.endTime.min`, '');

                                  form.change(`${fieldName}.startTime.hours`, '');
                                  form.change(`${fieldName}.startDate.date`, '');
                                  form.change(`${fieldName}.unpaidBreak`, '');
                                  form.change(`scheduleType`, '');
                                });
                                removeSelectedDate(fieldName, indx);
                                setValidStartDate(true);
                              }}
                            >
                              <FormattedMessage id="FilterForm.clear" />
                            </span>
                          </div>

                          <div className={css.TimeAndDateContainerDiv}>
                            <div className={css.TimeAndDateDiv}>
                              <label>{startTimeLabel}</label>

                              <div className={css.timeField}>
                                <FieldCustomSelect
                                  id={`${fieldName}.startTime.hours`}
                                  name={`${fieldName}.startTime.hours`}
                                  userNativeLang={userNativeLang}
                                  options={hourOptionsArray}
                                  label={hourLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]: !values?.oneTimeScheduleList[indx]
                                      ?.startDate?.date,
                                  })}
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  onChange={e => {
                                    const selectedDateTime = values?.oneTimeScheduleList[indx]?.startDate?.date;
                                    const isSameDay = moment(selectedDateTime).isSame(minimumStartDate, 'day');

                                    const minStartHour = isSameDay ? minimumStartDate.hour() : 0;
                                    const minStartMinute = isSameDay ? minimumStartDate.minute() : 0;

                                    handleStartTimeChange({
                                      val: e,
                                      fieldName,
                                      minStartHour,
                                      minStartMinute
                                    });
                                  }}
                                  disabled={!values?.oneTimeScheduleList[indx]?.startDate?.date}
                                />
                                <FieldCustomSelect
                                  id={`${fieldName}.startTime.min`}
                                  name={`${fieldName}.startTime.min`}
                                  userNativeLang={userNativeLang}
                                  options={minuteOptionsArray}
                                  label={minuteLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]: !values?.oneTimeScheduleList[indx]
                                      ?.startTime?.hours,
                                  })}
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  onChange={e => handleStartTimeMinChange(e, fieldName)}
                                  disabled={!values?.oneTimeScheduleList[indx]?.startTime?.hours}
                                />
                              </div>
                            </div>

                            <div className={css.TimeAndDateDiv}>
                              <label>{endTimeLabel}</label>
                              <div className={css.timeField}>
                                <FieldCustomSelect
                                  id={`${fieldName}.endTime.hours`}
                                  name={`${fieldName}.endTime.hours`}
                                  userNativeLang={userNativeLang}
                                  options={endTimeOptions}
                                  label={hourLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]:
                                      values?.oneTimeScheduleList[indx]?.startTime?.hours &&
                                        values?.oneTimeScheduleList[indx]?.startTime?.min
                                        ? false
                                        : true,
                                  })}
                                  onChange={e => {
                                    handleEndTimeChange({
                                      val: e,
                                      fieldName,
                                      indx,
                                    });
                                  }}
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  ignoreFilter={true}
                                  disabled={
                                    values?.oneTimeScheduleList[indx]?.startTime?.hours &&
                                      values?.oneTimeScheduleList[indx]?.startTime?.min
                                      ? false
                                      : true
                                  }
                                />
                                <FieldCustomSelect
                                  id={`${fieldName}.endTime.min`}
                                  name={`${fieldName}.endTime.min`}
                                  userNativeLang={userNativeLang}
                                  options={endTimeMinOptions}
                                  label={minuteLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]: values?.oneTimeScheduleList[indx]?.endTime
                                      ?.hours
                                      ? false
                                      : true,
                                  })}
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  onChange={e => handleEndTimeMinChange(e, fieldName)}
                                  ignoreFilter={true}
                                  disabled={
                                    values?.oneTimeScheduleList[indx]?.endTime?.hours ? false : true
                                  }
                                />
                              </div>
                            </div>
                            <div className={css.TimeAndDateDiv}>
                              <FieldCustomSelect
                                id="BreakId"
                                name={`${fieldName}.unpaidBreak`}
                                userNativeLang={userNativeLang}
                                options={UnpaidBreakOptions}
                                label={breakTimeMessage}
                                placeholder={unpaidBreakPlaceholder}
                                className={classNames(css.fieldContainer, textfield)}
                                errorClassName={errorTextField}
                                validate={breakTimeValidator}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }}
            </FieldArray>
          ) : (
            <FieldArray name={'recurringScheduleList'}>
              {({ fields }) => {
                const { name } = fields;

                return (
                  <div>
                    {fields.map((fieldName, indx) => {
                      const isWeeklyRecurringInterval =
                        values?.recurringScheduleList?.[indx]?.recurringInterval.value === 'Weekly';

                      const selectedRecurringDays =
                        values?.recurringScheduleList?.[indx]?.recurringDays;

                      const minimumStartDate = moment()
                        .add(MIN_START_HOUR_DIFF, 'hours')
                        .add(0, 'minutes');

                      const minStartHour = moment(minimumStartDate).hour();
                      const minStartMinute = moment(minimumStartDate).minutes();

                      return (
                        <div
                          className={classNames(css.OneTimeMainContainer, {
                            [css.invalidSchedule]:
                              isValidStartDate === false && validStartDate === false,
                          })}
                          key={`recur${indx}`}
                        >
                          <div className={css.topDiv}>
                            <FieldCustomSelect
                              id="recurringInterval"
                              key={`${fieldName}.recurringInterval`}
                              name={`${fieldName}.recurringInterval`}
                              userNativeLang={userNativeLang}
                              options={recurringInterval}
                              label={recurringIntervalLabel}
                              placeholder={recurringIntervalPlaceholder}
                              className={classNames(css.fieldContainer, textfield)}
                              errorClassName={errorTextField}
                              validate={breakTimeValidator}
                              onChange={val => {
                                form.change(`${fieldName}.startDate.date`, '');
                                form.change(`${fieldName}.endDate.date`, '');
                                form.change(`${fieldName}.recurringInterval`, val);
                                form.change(`${fieldName}.recurringDays`, []);

                                form.change(`${fieldName}.startTime.hours`, '');
                                form.change(`${fieldName}.startTime.min`, '');

                                form.change(`${fieldName}.endTime.hours`, '');
                                form.change(`${fieldName}.endTime.min`, '');
                              }}
                            />
                            <span
                              className={css.clearBtn}
                              onClick={() => {
                                form.batch(() => {
                                  form.change(`${fieldName}.recurringInterval`, '');

                                  form.change(`${fieldName}.startTime.hours`, '');
                                  form.change(`${fieldName}.startTime.min`, '');

                                  form.change(`${fieldName}.endTime.hours`, '');
                                  form.change(`${fieldName}.endTime.min`, '');

                                  form.change(`${fieldName}.startDate.date`, '');
                                  form.change(`${fieldName}.endDate.date`, '');

                                  form.change(`${fieldName}.unpaidBreak`, '');
                                  form.change(`scheduleType`, '');
                                });
                                removeSelectedDate(fieldName, indx);
                                setValidStartDate(true);
                              }}
                            >
                              <FormattedMessage id="FilterForm.clear" />
                            </span>
                          </div>

                          <div>
                            <label
                              className={classNames(css.daysLabel, {
                                [css.disabledLabel]:
                                  (values?.recurringScheduleList &&
                                    values?.recurringScheduleList[0]?.recurringInterval.length ===
                                    0) ||
                                  values?.recurringScheduleList[0]?.recurringInterval?.value ===
                                  'Daily',
                              })}
                            >
                              <FormattedMessage id="SearchPage.Days" />
                            </label>

                            <FieldCheckboxGroup
                              selectedClassName={css.customSelectedCheckbox}
                              className={classNames(css.customCheckbox, {
                                [css.disabledCheckBox]:
                                  (values?.recurringScheduleList &&
                                    values?.recurringScheduleList[0]?.recurringInterval.length ===
                                    0) ||
                                  values?.recurringScheduleList[0]?.recurringInterval?.value ===
                                  'Daily',
                              })}
                              selectedValuesArray={selectedRecurringDays}
                              id={`${fieldName}.recurringDays`}
                              key={`${fieldName}.recurringDays`}
                              name={`${fieldName}.recurringDays`}
                              options={recurringDaysOptions}
                              userNativeLang={userNativeLang}
                              intervalType={
                                (values?.recurringScheduleList &&
                                  values?.recurringScheduleList[0]?.recurringInterval.length ===
                                  0) ||
                                values?.recurringScheduleList[0]?.recurringInterval?.value
                              }
                            />
                          </div>
                          <div className={css.SelectDateContainer}>
                            <FieldDateInput
                              id={`${fieldName}.startDate`}
                              key={`${fieldName}.startDate`}
                              name={`${fieldName}.startDate`}
                              className={classNames(css.datefield, textfield, {
                                [css.invalidDate]: validDateRange === false,
                              })}
                              disabled={!values?.recurringScheduleList[indx]?.recurringInterval}
                              label={startDateLabel}
                              validate={startTitleValidator}
                              errorClassName={errorTextField}
                              userNativeLang={userNativeLang}
                              isDayBlocked={date => moment(date).isBefore(minimumStartDate, 'day')}
                              onChange={startDate => {
                                form.change(`${fieldName}.endDate.date`, '');
                                setValidDateRange(null);
                                const selectedDateTime = moment(startDate.date).set({
                                  hours: startDate,
                                  minutes: startMinute,
                                  seconds: 0,
                                });
                                handleStartTimeOptions(
                                  selectedDateTime,
                                  minimumStartDate,
                                  fieldName
                                );
                              }}
                            />

                            <FieldDateInput
                              id={`${fieldName}.endDate`}
                              key={`${fieldName}.endDate`}
                              name={`${fieldName}.endDate`}
                              className={classNames(css.datefield, textfield, {
                                [css.invalidDate]: validDateRange === false,
                              })}
                              label={endDateLabel}
                              disabled={!values?.recurringScheduleList[indx]?.startDate?.date}
                              validate={startTitleValidator}
                              errorClassName={errorTextField}
                              userNativeLang={userNativeLang}
                              isDayBlocked={date => {
                                return moment(date).isSameOrBefore(
                                  moment(values?.recurringScheduleList[indx]?.startDate.date)
                                );
                              }}
                              onChange={endDate => {
                                {
                                  selectedRecurringDays?.length > 0 &&
                                    isDateRangeValid(
                                      values?.recurringScheduleList[indx]?.startDate?.date,
                                      endDate?.date,
                                      selectedRecurringDays
                                    );
                                }
                              }}
                            />
                          </div>
                          {validDateRange === false ? (
                            <span className={css.errorMsg}>
                              <FormattedMessage id="SignupForm.invalidDateRange" />
                            </span>
                          ) : null}
                          <div className={css.TimeAndDateContainerDiv}>
                            <div className={css.TimeAndDateDiv}>
                              <label>{startTimeLabel}</label>
                              <div className={css.timeField}>
                                <FieldCustomSelect
                                  id={`${fieldName}.startTime.hours`}
                                  name={`${fieldName}.startTime.hours`}
                                  userNativeLang={userNativeLang}
                                  options={hourOptionsArray}
                                  label={hourLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]: !values?.recurringScheduleList[indx]
                                      ?.startDate?.date,
                                  })}
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  onChange={e =>
                                    handleRecurringStartTimeChange({
                                      val: e,
                                      fieldName,
                                      minStartHour,
                                      minStartMinute,
                                    })
                                  }
                                  disabled={!values?.recurringScheduleList[indx]?.startDate?.date}
                                />

                                <FieldCustomSelect
                                  id={`${fieldName}.startTime.min`}
                                  name={`${fieldName}.startTime.min`}
                                  userNativeLang={userNativeLang}
                                  options={minuteOptionsArray}
                                  label={minuteLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]: values?.recurringScheduleList[indx]
                                      ?.startTime?.hours
                                      ? false
                                      : true,
                                  })}
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  onChange={e => handleRecurringStartTimeChange(e, fieldName)}
                                  disabled={
                                    values?.recurringScheduleList[indx]?.startTime?.hours
                                      ? false
                                      : true
                                  }
                                />
                              </div>
                            </div>
                            <div className={css.TimeAndDateDiv}>
                              <label>{endTimeLabel}</label>
                              <div className={css.timeField}>
                                <FieldCustomSelect
                                  id={`${fieldName}.endTime.hours`}
                                  name={`${fieldName}.endTime.hours`}
                                  userNativeLang={userNativeLang}
                                  options={endTimeOptions}
                                  label={hourLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]:
                                      values?.recurringScheduleList[indx]?.startTime?.hours &&
                                        values?.recurringScheduleList[indx]?.startTime?.min
                                        ? false
                                        : true,
                                  })}
                                  onChange={e =>
                                    handleRecurringEndTimeChange({ val: e, fieldName, indx })
                                  }
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  ignoreFilter={true}
                                  disabled={
                                    values?.recurringScheduleList[indx]?.startTime?.hours &&
                                      values?.recurringScheduleList[indx]?.startTime?.min
                                      ? false
                                      : true
                                  }
                                />
                                <FieldCustomSelect
                                  id={`${fieldName}.endTime.min`}
                                  name={`${fieldName}.endTime.min`}
                                  userNativeLang={userNativeLang}
                                  options={endTimeMinOptions}
                                  label={minuteLabel}
                                  className={classNames(css.fieldContainer, textfield, {
                                    [css.fieldDisabled]: values?.recurringScheduleList[indx]
                                      ?.endTime?.hours
                                      ? false
                                      : true,
                                  })}
                                  errorClassName={errorTextField}
                                  validate={breakTimeValidator}
                                  ignoreFilter={true}
                                  disabled={
                                    values?.recurringScheduleList[indx]?.endTime?.hours
                                      ? false
                                      : true
                                  }

                                />
                              </div>
                            </div>
                            <div className={css.TimeAndDateDiv}>
                              <FieldCustomSelect
                                id="recurringBreakId"
                                key={`${fieldName}.unpaidBreak`}
                                name={`${fieldName}.unpaidBreak`}
                                userNativeLang={userNativeLang}
                                options={UnpaidBreakOptions}
                                label={breakTimeMessage}
                                placeholder={unpaidBreakPlaceholder}
                                className={classNames(css.fieldContainer, textfield)}
                                errorClassName={errorTextField}
                                validate={breakTimeValidator}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }}
            </FieldArray>
          )}
          {isValidStartDate === false && validStartDate === false ? (
            <span className={css.errorMsg}>
              <FormattedMessage id="scheduleTab.invalidDateRange" />
            </span>
          ) : null}
          <div className={css.ButtonContainer}>
            { }
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={() =>
                history.replace(
                  createResourceLocatorString('ManageListingsPage', routeConfiguration())
                )
              }
            >
              <FormattedMessage id="SignupForm.Cancel" />
            </InlineTextButton>
          </div>
        </Form>
      );
    }}
  />
);
EditListingSchedulingFormComponent.defaultProps = { className: null, fetchErrors: null };

EditListingSchedulingFormComponent.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    createListingDraftError: propTypes.error,
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  certificateOptions: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
};

export default compose(injectIntl)(EditListingSchedulingFormComponent);
